import performance from '@atlassian/jira-common-performance/src/performance.tsx';
import type { State } from '../../../../state/reducers/types';
import { getTimeWhenLastInitialized } from '../../../../state/selectors/issues';

// This selector is *not* pure
export const getTimeSinceIssueListInitialized = (state: State): number =>
	Math.round(performance.now() - getTimeWhenLastInitialized(state));
